/**
 * Compact relative timestamp for feed rows ("42s", "3m", "5h", "2d").
 * Falls back to a short date for anything older than a week.
 */
export function formatRelativeTime(unixTs: number): string {
  const diff = Math.floor(Date.now() / 1000) - unixTs;
  if (diff < 10) return 'now';
  if (diff < 60) return `${diff}s`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d`;
  return new Date(unixTs * 1000).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
